<template>
	<div class="loadings.main">
		<el-form
			ref="editorForm"
			:model="info"
			status-icon
			label-position="left"
			label-width="120px"
			size="mini"
			v-loading="loadings.main"
			v-if="hasGetTableDataModel"
			@submit.native.prevent
			:rules="rules"
		>
			<div class="row">
				<div :class="key.col?'col-md-'+key.col:'col-md-12'" v-for="(key,index) in fields" :key="index">
					<el-form-item :label="dataModels.Product_color[key.name].show_name" :prop="key.name">
						<field-editor
							:width="key.width"
							v-model="info[key.name]"
							@change.native="handleFormEdited"
							@change="handleFormEdited"
							:field-info="dataModels.Product_color[key.name]"
							record-model="Product_color"
							:tips="key.tips"
							:params="key.params"
							:record-id="recordId"
						></field-editor>
					</el-form-item>
				</div>
			</div>
		</el-form>
		<div slot="footer" class="dialog-footer" v-loading="loadings.formLoading">
			<el-button size="mini" type="primary" @click="doConfirmEdit()">确 定</el-button>
		</div>
	</div>
</template>

<script>
import FieldEditor from "@/components/FieldEditor.vue";
import LoadDM from "@/mixins/LoadDM.js";

export default {
	mixins: [LoadDM],
	data() {
		return {
			loadings: {
				formLoading: false,
				main: false,
				items: false
			},
			dataModelName: "Product_color",
			styles: [],
			everEdited: false,
			rules: {
				// intro: [
				// 	{
				// 		required: true,
				// 		message: "请输入",
				// 		trigger: "change"
				// 	}
				// ]
			},
			fields: [
				{
					name: "meta_main_material",
					col: 4,
					tips: "复合材质可以录入 复合，然后在材质描述列出"
					// width: "100%"
				},
				{
					name: "meta_madein",
					col: 4
					// width: "100%"
				},
				{
					name: "meta_style",
					col: 4
					// width: "100%"
				},
				{
					name: "meta_materials",
					col: 12,
					width: "100%",
					params: {
						row: 5
					}
				},
				{
					name: "briefs",
					col: 12,
					width: "100%",
					params: {
						row: 5
					},
					tips: "一行一条即可，例如：可拆卸可调肩带"
				},
				{
					name: "intro",
					col: 12
					// width: "100%"
				}
			],
			items: []
		};
	},
	props: {
		value: {
			type: Object,
			default: () => {
				return {};
			}
		},
		recordId: {
			type: String,
			default: ""
		}
	},
	mounted() {},
	computed: {
		info: {
			// getter
			get: function() {
				let info = JSON.parse(JSON.stringify(this.value));
				return info;
			}
		}
	},
	methods: {
		handleFormEdited() {
			this.everEdited = true;
			this.$emit("change", JSON.parse(JSON.stringify(this.info)));
		},
		handleSelect() {},

		doConfirmEdit() {
			if (!this.everEdited) {
				this.$message.warning("数据无变化");
				return;
			}
			this.$refs["editorForm"].validate(valid => {
				if (!valid) {
					return false;
				}
				this.loadings.formLoading = true;
				let post = this.info;

				this.$axios
					.post(`/spu/do_edit_intro/${this.recordId}`, post)
					.then(json => {
						this.loadings.formLoading = false;
						for (let k in json.data.info) {
							this.$set(this.info, k, json.data.info[k]);
						}
						this.$message.success("成功");
						this.$emit("change", JSON.parse(JSON.stringify(this.info)));
					})
					.catch(json => {
						this.loadings.formLoading = false;
						this.$message.error(json.data.msg);
					});
			});
		}
	},
	components: {
		FieldEditor
	}
};
</script>